export function formatMobileNumber({ mobile_number, ...rest }: any) {
  return {
    mobile_number: mobile_number?.replace("+639", "639"),
    ...rest
  };
}

export function parseMobileNumber(str: string) {
  return (str || "").replace("639", "+639");
}
